export default "__VITE_ASSET__DEHRAd8B__"